import { useState } from "react";
import { motion } from "framer-motion";

// 5 segments. Index 2 (centre) is the weekly grand prize: FREE Service worth ₹5000.
// Keep this in lockstep with backend PRIZES_WHEEL order in routes_public.py.
export const WHEEL_SEGMENTS = [
  { label: "30% OFF LABOR", color: "#FF5A00", text: "#FFFFFF" },
  { label: "FREE CAR WASH", color: "#1F1F1F", text: "#FFFFFF" },
  { label: "₹5000 FREE SERVICE", color: "#D4AF37", text: "#0A0A0A", isGrand: true },
  { label: "FREE ALIGNMENT", color: "#C24400", text: "#FFFFFF" },
  { label: "50% OFF LABOR", color: "#141414", text: "#FFFFFF" },
];

const SEG_COUNT = WHEEL_SEGMENTS.length;
const SEG_DEG = 360 / SEG_COUNT; // 72°
const R = 145;
const C = 150;

function segPath(i) {
  // Start at top (-90°), each segment spans SEG_DEG clockwise.
  const a0 = ((i * SEG_DEG - 90) * Math.PI) / 180;
  const a1 = (((i + 1) * SEG_DEG - 90) * Math.PI) / 180;
  const x0 = C + R * Math.cos(a0);
  const y0 = C + R * Math.sin(a0);
  const x1 = C + R * Math.cos(a1);
  const y1 = C + R * Math.sin(a1);
  const largeArc = SEG_DEG > 180 ? 1 : 0;
  return `M${C},${C} L${x0.toFixed(2)},${y0.toFixed(2)} A${R},${R} 0 ${largeArc} 1 ${x1.toFixed(2)},${y1.toFixed(2)} Z`;
}

export function SpinWheel({ rotation, onComplete, spinning }) {
  const [done, setDone] = useState(false);
  return (
    <div className="relative w-[280px] h-[280px] sm:w-[340px] sm:h-[340px] mx-auto" data-testid="spin-wheel">
      {/* Pointer */}
      <div className="absolute left-1/2 -translate-x-1/2 -top-2 z-10">
        <div className="w-0 h-0 border-l-[12px] border-r-[12px] border-t-[20px] border-l-transparent border-r-transparent border-t-[#FF5A00] drop-shadow-lg" />
      </div>
      <motion.div
        className="w-full h-full wheel-glow"
        animate={{ rotate: rotation }}
        transition={{ duration: 4.6, ease: [0.12, 0.8, 0.2, 1] }}
        onAnimationComplete={() => {
          if (spinning && !done) {
            setDone(true);
            onComplete?.();
          }
        }}
      >
        <svg viewBox="0 0 300 300" className="w-full h-full">
          <circle cx={C} cy={C} r={R + 4} fill="#0A0A0A" stroke="#FF5A00" strokeWidth="3" />
          {WHEEL_SEGMENTS.map((seg, i) => (
            <path
              key={i}
              d={segPath(i)}
              fill={seg.color}
              stroke="#0A0A0A"
              strokeWidth="2"
            />
          ))}
          {WHEEL_SEGMENTS.map((seg, i) => {
            const mid = ((i * SEG_DEG + SEG_DEG / 2 - 90) * Math.PI) / 180;
            const tx = C + 95 * Math.cos(mid);
            const ty = C + 95 * Math.sin(mid);
            const deg = i * SEG_DEG + SEG_DEG / 2;
            const words = seg.label.split(" ");
            return (
              <text
                key={i}
                x={tx}
                y={ty}
                fill={seg.text}
                fontSize={seg.isGrand ? 11 : 11}
                fontWeight="900"
                fontFamily="Outfit, sans-serif"
                textAnchor="middle"
                transform={`rotate(${deg} ${tx} ${ty})`}
              >
                {words.map((w, j) => (
                  <tspan
                    key={j}
                    x={tx}
                    dy={j === 0 ? -(words.length - 1) * 6 : 12}
                  >
                    {w}
                  </tspan>
                ))}
              </text>
            );
          })}
          <circle cx={C} cy={C} r="26" fill="#0A0A0A" stroke="#FF5A00" strokeWidth="3" />
          <text x={C} y={C + 5} fill="#FF5A00" fontSize="13" fontWeight="900" textAnchor="middle" fontFamily="Outfit, sans-serif">
            AHQ
          </text>
        </svg>
      </motion.div>
    </div>
  );
}

// Helper used by SpinSection to compute target rotation given winning segment index.
// Rotates clockwise so the pointer (at top) lands on the centre of segment `idx`.
export function rotationForIndex(idx) {
  const target = idx * SEG_DEG + SEG_DEG / 2; // centre angle of segment, in deg from top
  return 1800 + (360 - target);
}
